import React from 'react';
import { useContent } from '../context/ContentContext';
import DomainInput from '../components/DomainInput';
import CategorySelector from '../components/CategorySelector';
import BlogList from '../components/BlogList';
import { useNavigate } from 'react-router-dom';
import RecursiveDropdown from '../components/RecursiveDropdown';

function Home() {
  const {
    domain,
    setDomain,
    categories,
    selectedCategory,
    setSelectedCategory,
    blogs,
    error,
    setError,
    loadingCategories,
    loadingPosts,
  } = useContent();

  console.log(selectedCategory);

  const navigate = useNavigate();

  const handlePostClick = (post) => {
    navigate('/linking-to/' + post.url.split('/').filter(Boolean).pop() + '/');
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <h1 className="text-3xl font-bold mb-6 text-center">Internal Linking Analyzer</h1>
      <DomainInput domain={domain} setDomain={setDomain} setError={setError} />
      {error && <p className="text-red-600 mt-2">{error}</p>}
      {loadingCategories && <p className="text-gray-600 mt-2">Loading categories...</p>}
      {categories.length > 0 && (
        // <CategorySelector
        //   categories={categories}
        //   selectedCategory={selectedCategory}
        //   setSelectedCategory={setSelectedCategory}
        // />
        <RecursiveDropdown
          categories={categories}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
        />
      )}
      {loadingPosts && <p className="text-gray-600 mt-2">Loading posts...</p>}
      {blogs.length > 0 && (
        <BlogList
          blogs={blogs}
          onPostClick={handlePostClick}
        />
      )}
    </div>
  );
}

export default Home;
